var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"el-icon-arrow-left",on:{"click":_vm.backBefor}},[_vm._v(_vm._s(_vm.title || _vm.$route.meta.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }